import { render, staticRenderFns } from "./GameTrackingPage.vue?vue&type=template&id=cdefd88e&scoped=true"
import script from "./GameTrackingPage.vue?vue&type=script&lang=js"
export * from "./GameTrackingPage.vue?vue&type=script&lang=js"
import style0 from "./GameTrackingPage.vue?vue&type=style&index=0&id=cdefd88e&prod&scoped=true&lang=css"
import style1 from "./GameTrackingPage.vue?vue&type=style&index=1&id=cdefd88e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdefd88e",
  null
  
)

export default component.exports